import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import { IGirafePanel } from '@geogirafe/lib-geoportal/core';

export default class ImprintComponent extends GirafeHTMLElement implements IGirafePanel {
  templateUrl = './template.html';
  styleUrls = ['../../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', './style.css'];

  isPanelVisible = false;
  panelTitle = 'Impressum';
  panelTogglePath = 'extendedState.imprintPanel.visible';

  public constructor() {
    super('imprint-component');
  }

  public togglePanel(visible: boolean) {
    if (this.isPanelVisible == visible) return;
    this.isPanelVisible = visible;
    this.render();
  }

  protected override connectedCallback() {
    super.connectedCallback();
    this.state.extendedState.imprintPanel = {
      visible: false
    };
    this.render();
  }

  override render(): void {
    if (this.isPanelVisible) {
      super.render();
    } else {
      this.hide();
    }
  }
}
